/* eslint-disable @typescript-eslint/no-explicit-any */
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'

const HelperLogic = ({ Wrapper }: { Wrapper: any }) => {
  const { parsedHelpers } = useHeaderContext()

  return <Wrapper parsedHelpers={parsedHelpers} />
}

export default HelperLogic
